/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import {
  buildImagePath,
  parseUrlConfigParams,
} from '../../../../utils/cloudinary';
import * as styles from './index.styles';

const flagSizeConfig = parseUrlConfigParams({
  ...CLOUDINARY_BASE_VALUES,
  width: 56,
}).config;

export class LanguageItem extends SafePureComponent {
  safeRender() {
    const { language, t } = this.props;
    const { flag, name } = language;

    return (
      <React.Fragment>
        <div css={styles.languageFlagCss}>
          <img src={buildImagePath(flagSizeConfig, flag)} alt={name} />
        </div>
        <div css={styles.languageTextCss}>
          <span css={styles.languageNameCss}>{t(`${name}Title`)}</span>
          <span css={styles.languageDescriptionCss}>
            {t(`${name}Description`)}
          </span>
        </div>
      </React.Fragment>
    );
  }
}

export default LanguageItem;
